export const personal = {
  name: "Ashish Suryavanshi",
  firstName: "Ashish",
  lastName: "Suryavanshi",
  title: "Full Stack Developer",
  roles: ["Full Stack Developer", "UI/UX Designer", "React Engineer", "Problem Solver"],
  bio: "I am passionate about engineering digital experiences that combine performance, design, and innovation. With a strong focus on clean code and modern technologies, I transform complex problems into elegant, interactive solutions that deliver meaningful user experiences.",
  email: "ashishsuryavanshi005@gmail.com",
  phone: "+91 8349277101",
  linkedin: "ashish-suryavanshi",
  github: "ashish-suryavanshi",
  twitter: "ashish_dev",
  instagram: "ashish.dev",
  facebook: "ashish.suryavanshi",
  resume: "https://drive.google.com/file/d/1FqU-Ki3iQoYbBOuvlHrbBPIlpH2O4DFQ/view?usp=sharing",
  location: "Bhopal, MP, India",
};

export const achievements = [
  {
    id: 1,
    title: "Distinctive Performance in Board Class",
    description: "Secured 1st position in board class at city level and awarded ₹2001 by the Nagar Palika in recognition of academic excellence.",
    icon: "🏆", color: "#00f5ff", year: "2022",
    link: "https://drive.google.com/file/d/1g9lEjEaqiy1DXoqq_yglu5rj-LNVrNGk/view?usp=sharing",
  },
  {
    id: 2,
    title: "Chief Minister Scooty Scheme",
    description: "Awarded a scooty under the Madhya Pradesh Chief Minister Scheme for top-performing students across the state.",
    icon: "🛵", color: "#bf00ff", year: "2022",
    link: "https://drive.google.com/file/d/1_vtAnJVy87fyKm-_uzratNcF2sBcyakt/view?usp=sharing",
  },
  {
    id: 3,
    title: "General Knowledge Competition",
    description: "Secured 3rd position in a City-level GK competition and awarded ₹2100 in recognition of performance.",
    icon: "🌍", color: "#00ff88", year: "2021",
    link: "https://drive.google.com/file/d/1_YPTT2DvWiSWsroP0i4c4fM5_B1sgKrR/view?usp=sharing",
  },
  {
    id: 4,
    title: "INSPIRE Award – MANAK",
    description: "Selected for District Level Science Exhibition under INSPIRE AWARD - MANAK Scheme and awarded ₹10,000 for an innovative science project.",
    icon: "🔬", color: "#ff0080", year: "2020",
    link: "https://drive.google.com/file/d/1_j7bymS1XjEUQQYMb8LPRk7EFLO7pExa/view?usp=sharing",
  },
];

export const technicalAchievements = [
  {
    id: 1,
    title: "LeetCode",
    description: "Solved 700+ Data Structures & Algorithms problems.",
    icon: "💻", color: "#f0ad4e"
  },
  {
    id: 2,
    title: "Amazon ML Summer School 2026",
    description: "Selected for the Selection Test stage.",
    icon: "🤖", color: "#ff9900"
  },
  {
    id: 3,
    title: "Google Cloud Arcade",
    description: "Achieved Premium+ milestone in the Google Cloud Arcade Facilitator Program.",
    icon: "☁️", color: "#4285F4"
  },
  {
    id: 4,
    title: "Smart India Hackathon (SIH)",
    description: "Selected at the college-level hackathon.",
    icon: "🚀", color: "#00f5ff",
    link: "https://drive.google.com/file/d/13MU60YG2RcsxZUTZXRwTNH4N_Vz58yQi/view?usp=sharing"
  },
  {
    id: 5,
    title: "Technovision Ideathon",
    description: "Participated in the Ideathon.",
    icon: "💡", color: "#bf00ff",
    link: "https://drive.google.com/file/d/1mouNSBGbW2MOlX8C_U_jBrBO1tM8cyU_/view?usp=sharing"
  }
];

export const projects = [
  {
    id: 1,
    title: "YouTube Clone",
    highlight: "YouTube",
    desc: "Developed the front-end using HTML, CSS and JavaScript. Implemented responsive layout and custom video grid using CSS Flexbox and Grid.",
    tags: ["HTML5", "CSS3", "JavaScript", "Flexbox"],
    color: "#ff0000", accent: "#00f5ff",
    link: "https://youtube-clone-darkknowledge.netlify.app/", mockupContent: "youtube",
  },
  {
    id: 2,
    title: "Amazon Clone — Frontend Replica",
    highlight: "Amazon Clone",
    desc: "A responsive Amazon-like UI replicating key e-commerce features — product display, search bar, cart layout — using vanilla web technologies.",
    tags: ["HTML5", "CSS3", "JavaScript", "Grid"],
    color: "#ff9900", accent: "#bf00ff",
    link: "https://amazon-clone-replica-darkknowledge.netlify.app/", mockupContent: "amazon",
  },
  {
    id: 3,
    title: "HealthMitra — Full Stack Web",
    highlight: "HealthMitra",
    desc: "A comprehensive healthcare application integrating a React frontend with a robust Spring Boot backend. Includes secure authentication, seamless data flow, and responsive UI components.",
    tags: ["React.js", "Java", "Spring Boot", "Spring MVC", "Tailwind CSS", "REST API"],
    color: "#14b8a6", accent: "#0ea5e9",
    link: "https://pro-health-mitra.vercel.app/",
    mockupContent: "healthmitra",
  },
  {
    id: 4,
    title: "AI-FinTech - Full Stack Web",
    highlight: "AI-FinTech",
    desc: "Designed and implemented an AI-based financial application that analyzes market data and user financial behavior to provide personalized financial advice and data-driven predictions.",
    tags: ["React.js", "Tailwind CSS", "Nodejs", "Express.js", " MongoDB", "Python", " LSTM", "yFinance API"],
    color: "#00f5ff", accent: "#bf00ff",
    link: "https://ai-driven-fintech.vercel.app/",
    mockupContent: "aifintech",
  },
  {
    id: 5,
    title: "E-NagarSetu - Full Stack Web",
    highlight: "E-NagarSetu",
    desc: "E-NagarSetu is a digital municipal services platform designed to connect citizens with local government services. It enables users to access municipal services, submit applications, and report civic issues online.",
    tags: ["React.js", "Tailwind CSS", "Java","Spring Boot", "MongoDB", "REST APIs", "MongoDB"],
    color: "#72ef72", accent: "#00f5ff",
    link: "https://e-nagar-setu.vercel.app/",
    mockupContent: "e-nagarsetu",
  },
  {
    id: 6,
    title: "AI-Interview Agent - AI Powered Web App",
    highlight: "AI-Interview Agent",
    desc: "Built an AI-powered interview platform that conducts interviews, evaluates candidate responses across technical, communication, and problem-solving skills, and generates structured scores with performance feedback reports.",
    tags: ["React.js", "Tailwind CSS", "Java","Spring Boot", "REST APIs", "AI API"],
    color: "#9585f0", accent: "#00f5ff",
    link: "https://ab-talks-interview-agent.vercel.app/",
    mockupContent: "AI-Interviewer",
  }
];

export const skills = [
  { name: "HTML5", level: 90, color: "#e34c26", icon: "🟧" },
  { name: "CSS3", level: 85, color: "#264de4", icon: "🟦" },
  { name: "JavaScript", level: 83, color: "#f0db4f", icon: "🟨" },
  { name: "React", level: 80, color: "#61dafb", icon: "⚛️" },
  { name: "Python", level: 75, color: "#3572A5", icon: "🐍" },
  { name: "Java", level: 88, color: "#b07219", icon: "☕" },
  { name: "MySQL", level: 78, color: "#00758f", icon: "🐬" },
  { name: "Spring Boot", level: 60, color: "#68a063", icon: "🍃" },
  { name: "Git", level: 82, color: "#f34f29", icon: "🔧" },
  { name: "Canva", level: 73, color: "#00c4cc", icon: "🎨" },
];

export const techStack = [
  { name: "HTML5", color: "#e34c26" },
  { name: "CSS3", color: "#264de4" },
  { name: "JavaScript", color: "#f0db4f" },
  { name: "React", color: "#61dafb" },
  { name: "Python", color: "#3572A5" },
  { name: "Java", color: "#b07219" },
  { name: "MySQL", color: "#00758f" },
  { name: "Node.js", color: "#68a063" },
  { name: "Git", color: "#f34f29" },
  { name: "Canva", color: "#00c4cc" },
  { name: "Figma", color: "#a259ff" },
  { name: "VS Code", color: "#007acc" },
];
